<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jTyyFv/tc-custom/9781607051497.jpg?1737686687012" alt="This image is the cover for the book Flying Colors"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Flying Colors
      </h1>
      <p class="bookDescription body article font2">
        <b>Tips and techniques for unleashing the designer within and creating your own original quilts.</b><br/><br/>Let your imagination take flight! Gail Garber teaches you step-by-step techniques to create your own unique quilt designs, or to make any of the five bonus projects in this book. <br/><br/>Draft shapes such as Flying Geese, triangles, and diamonds to fill strips of fabric that weave in and out of your design. Easy paper-piecing instructions help you make all your designs more accurate, from landscapes to radiating sunlight to flowing ribbons. Links to full-size foundation patterns are included, plus a gallery of quilts made by Gail and her students. Learn how to make intriguing quilts with techniques for using free-form strips and shapes to create dimension, illusion, and flow. There’s no limit to the designs you can invent!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gail Garber
      </h2>
      
      <p class="authorDescription body article">Gail Garber first started quilting in 1980, and hasn't looked back since. Her award-winning work has been exhibited in numerous shows and published in a number of quilting magazines.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      C&T Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7c98c8ff